export enum OauthButtonType {
  Jira = 'Jira',
  Provider = 'Provider',
  Gmail = 'Gmail',
}
